var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.payType==6)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.examHtml)}}):_c('div',{staticStyle:{"padding-top":"100px","margin":"0 auto 0","text-align":"center"}},[_c('h2',{staticStyle:{"text-align":"center","margin":"0"}},[_vm._v("微信支付")]),_vm._v(" "),_c('img',{staticStyle:{"width":"200px"},attrs:{"src":_vm.examHtml}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8cfb0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pay/Orderz.vue
// module id = null
// module chunks = 